import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import MedicalHistoryConfigUpdate from './MedicalHistoryConfigUpdate';
import { MedicalHistoryType } from '../../../../../../graphql/graphql';

interface Props extends BaseModalProps {
	item: MedicalHistoryType;
	onUpdate: () => void;
}

const MedicalHistoryConfigUpdateModal: React.FC<Props> = props => (
	<BaseModal {...props} title='component.medicalHistoryConfigUpdate.title'>
		<MedicalHistoryConfigUpdate item={props.item} onUpdate={props.onUpdate} />
	</BaseModal>
);

export default MedicalHistoryConfigUpdateModal;
